import { Message, Notification, MessageBox } from 'element-ui'

export default {
  // 深度复制
  deepCopy: function(sourceObj) {
    if (sourceObj) { return JSON.parse(JSON.stringify(sourceObj)) } else {
      return undefined
    }
  },

  // 数组去重
  ArrayDistinct: function(arr) {
    var hash = []
    for (var i = 0; i < arr.length; i++) {
      if (hash.indexOf(arr[i]) === -1) {
        hash.push(arr[i])
      }
    }
    return hash
  },

  // 数组排序比较
  sortBy: function(attr, rev) {
    // 第二个参数没有传递 默认升序排列
    if (rev === undefined) {
      rev = 1
    } else {
      rev = (rev) ? 1 : -1
    }
    return function(a, b) {
      a = a[attr]
      b = b[attr]
      if (a < b) {
        return rev * -1
      }
      if (a > b) {
        return rev * 1
      }
      return 0
    }
  },

  // 数组group by
  groupBy: function(list, fn) {
    const groups = {}
    list.forEach(function(o) {
      const group = JSON.stringify(fn(o))
      groups[group] = groups[group] || []
      groups[group].push(o)
    })
    return groups
  },

  // 获取blobURL地址
  getFileURL(file) {
    var getUrl = null
    if (window.createObjectURL !== undefined) { // basic
      getUrl = window.createObjectURL(file)
    } else if (window.URL !== undefined) { // mozilla(firefox)
      getUrl = window.URL.createObjectURL(file)
    } else if (window.webkitURL !== undefined) { // webkit or chrome
      getUrl = window.webkitURL.createObjectURL(file)
    }
    return getUrl
  },

  // base64转换为blob
  b64toBlob(b64Data, contentType, sliceSize) {
    contentType = contentType || ''
    sliceSize = sliceSize || 512
    var byteCharacters = atob(b64Data)
    var byteArrays = []
    for (var offset = 0; offset < byteCharacters.length; offset += sliceSize) {
      var slice = byteCharacters.slice(offset, offset + sliceSize)
      var byteNumbers = new Array(slice.length)
      for (var i = 0; i < slice.length; i++) {
        byteNumbers[i] = slice.charCodeAt(i)
      }
      var byteArray = new Uint8Array(byteNumbers)
      byteArrays.push(byteArray)
    }
    var blob = new Blob(byteArrays, { type: contentType })
    return blob
  },

  // 通知提示信息
  alertMessage(title, message) {
    MessageBox.alert(message, title, {
      confirmButtonText: '确定'
    })
  },

  // 通知提示信息
  noticeMessage(title, message) {
    Notification.success({
      title: title,
      message: message,
      type: 'success',
      duration: 5000
    })
  },

  // 提示提示信息
  warningMessage(message) {
    Message.warning({
      message: message,
      type: 'warning',
      showClose: true,
      duration: 5000
    })
  },

  // 错误提示信息
  errorMessage(message, exception) {
    var messageStr
    if (message instanceof Error) {
      messageStr = '错误：' + message.message
    } else {
      messageStr = message
    }
    if (exception instanceof Error && exception.response) {
      if (exception.response.data) {
        messageStr = JSON.stringify(exception.response.data) || message
      }
    }
    if (message instanceof Array && !messageStr) {
      messageStr = message[0]
      for (var i = 1; i < message.length; i++) {
        messageStr += '<br >' + message[i]
      }
    }
    Message.error({
      dangerouslyUseHTMLString: true,
      showClose: true,
      message: messageStr,
      type: 'error',
      duration: 5000
    })
    if (exception instanceof Error) {
      console.error(exception)
    } else {
      // debugger
      console.error(new Error(exception || messageStr))
    }
  }
}
